import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function HeroSectionV2() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-12 pb-20 px-4 md:pt-20 md:pb-28 overflow-hidden bg-gradient-to-b from-[#FFF8F0] to-[#FFE0B2]/30" data-id="element-406">
      <div className="max-w-lg md:max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-407">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-408">
          <span className="inline-block py-1 px-3 rounded-full bg-[#E8F5E9] text-[#2E7D32] text-sm font-bold mb-6 tracking-wide" data-id="element-409">
            🥦 NUTRIPEQUES
          </span>
        </motion.div>

        {/* Headline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-410">
          <h1 className="text-3xl md:text-5xl lg:text-[3.4rem] font-black text-gray-900 leading-[1.15] mb-6 text-balance" data-id="element-411">
            Tu hijo no rechaza la comida.{' '}
            <span className="text-[#FF8A65]" data-id="element-412">Rechaza el caos.</span>
            <br className="hidden md:block" data-id="element-413" />
            <span className="block mt-2 text-2xl md:text-4xl lg:text-[2.6rem] font-extrabold text-gray-700" data-id="element-414">
              Y no es tu culpa: nadie te explicó cómo solucionarlo.
            </span>
          </h1>
        </motion.div>

        {/* Subheadline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-415">
          <p className="text-lg md:text-2xl text-gray-700 mb-10 font-medium max-w-2xl leading-relaxed" data-id="element-416">
            NutriPeques: más de 60 recetas + sistema de planificación para mamás
            de niños de 1 a 7 años.
          </p>
        </motion.div>

        {/* Testimonial Card — 3D pop effect */}
        <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.3
      }} className="w-full max-w-lg mb-10 relative" data-id="element-417">
          <div className="absolute inset-0 bg-gradient-to-b from-orange-200/50 via-orange-100/30 to-transparent rounded-3xl blur-2xl scale-105 -z-10" data-id="element-418" />
          <div className="bg-white rounded-2xl p-5 md:p-7 border border-orange-100 shadow-[0_12px_40px_rgba(0,0,0,0.1),0_4px_16px_rgba(255,138,101,0.2)] relative" data-id="element-419">
            {/* Stars */}
            <div className="flex justify-center mb-3" data-id="element-420">
              <span className="text-lg tracking-wider" data-id="element-421">⭐⭐⭐⭐⭐</span>
            </div>
            <p className="text-gray-700 text-sm md:text-base leading-relaxed italic mb-4" data-id="element-422">
              "Pensaba que estaba fallando como mamá, me sentía muy frustrada,
              pero hoy a tres semanas de estar aplicando el contenido mi hijo de
              3 ya come verduras, nunca pensé que lo vería, me siento más
              tranquila con la alimentación de Mate gracias a NutriPeques."
            </p>
            <div className="flex items-center justify-center gap-2" data-id="element-423">
              <div className="w-8 h-8 rounded-full bg-[#FFE0B2] flex items-center justify-center text-sm font-bold text-[#E65100]" data-id="element-424">
                M
              </div>
              <span className="text-sm font-bold text-gray-800" data-id="element-425">
                Mariana, mamá de Mateo
              </span>
            </div>
          </div>
        </motion.div>

        {/* Product Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.45
      }} className="w-full max-w-md mx-auto mb-8 relative" data-id="element-426">
          <div className="absolute inset-0 bg-[#4CAF50]/20 blur-3xl rounded-full transform -translate-y-4" data-id="element-427"></div>
          <img src="https://cdn.magicpatterns.com/uploads/wkzGFuHWyP7z23EbiJvcUP/heylloyd-image-1772533088855.png" alt="NutriPeques Guía Práctica" className="w-full h-auto relative z-10 drop-shadow-2xl rounded-2xl" data-id="element-428" />
        </motion.div>

        {/* Trust Badges */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.55
      }} className="flex flex-wrap justify-center gap-4 md:gap-6 mb-8" data-id="element-429">
          {['Acceso inmediato', 'Garantía incondicional', 'Bonos incluidos'].map((badge, idx) => <div key={idx} className="flex items-center gap-1.5 text-sm md:text-base font-medium text-gray-700" data-id="element-430">
              <Check className="w-5 h-5 text-[#4CAF50] shrink-0" data-id="element-431" />
              <span data-id="element-432">{badge}</span>
            </div>)}
        </motion.div>

        {/* CTA Button — kept identical */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.65
      }} className="w-full max-w-md" data-id="element-433">
          <button onClick={scrollToOffer} className="w-full min-h-[64px] bg-[#2E7D32] hover:bg-[#1B5E20] text-white text-xl font-bold rounded-2xl shadow-[0_8px_0_#1B5E20] hover:shadow-[0_4px_0_#1B5E20] hover:translate-y-1 transition-all flex items-center justify-center gap-2 px-6" data-id="element-434">
            → Quiero nutrir con calma
          </button>
          <p className="text-sm text-gray-500 mt-6 flex items-center justify-center gap-2" data-id="element-435">
            <span className="flex items-center" data-id="element-436">⭐⭐⭐⭐⭐</span>
            <span data-id="element-437">+2,500 mamás ya lo usan</span>
          </p>
        </motion.div>
      </div>
    </section>;
}